import { NgModule } from '@angular/core';
import { BrandAssetPipe } from './brand-asset/brand-asset.pipe';
import { DocumentUploadedPipe } from './document-name/document-uploaded.pipe';
import { OrderByPipe } from './order/order.pipe';

@NgModule({
  declarations: [BrandAssetPipe, DocumentUploadedPipe, OrderByPipe],
  exports: [BrandAssetPipe, DocumentUploadedPipe, OrderByPipe]
})
export class PipesModule {}
